import { client, gql } from 'data-provider';

export interface ActivityLog {
  id: number;
  source: {
    tenantId: string;
  };
  action: string;
  record_id: string; // which is a module id (i.e. clientId or saleId)
  module_name: string;
  user_email: string;
  message: string;
  created_at: string;
  data: Record<string, { from: any; to: any }> | null;
  name: string;
}

export interface ActionModuleFilter {
  action: string;
  moduleName: string;
}

interface ActivityLogQuery {
  startDate?: string | null;
  endDate?: string | null;
  actionModule?: ActionModuleFilter[] | null;
  labelId?: string | null;
  userEmail?: string | null;
  start?: number;
  limit?: number;
  name?: string | null;
}

export const getActivityLogs = async (logQuery?: ActivityLogQuery) => {
  const query = gql`
    query TransactionLogs(
      $name: String
      $labelId: String
      $userEmail: String
      $startDate: String
      $endDate: String
      $start: Int
      $limit: Int
      $actionModule: [actionModuleArg!]
    ) {
      transactionLogs(
        labelId: $labelId
        userEmail: $userEmail
        startDate: $startDate
        endDate: $endDate
        start: $start
        limit: $limit
        actionModule: $actionModule
        name: $name
      ) {
        data
        page
        size
        total
      }
    }
  `;

  const variables = {
    startDate: logQuery && logQuery.startDate ? logQuery.startDate : undefined,
    endDate: logQuery && logQuery.endDate ? logQuery.endDate : undefined,
    actionModule: logQuery && logQuery.actionModule ? logQuery.actionModule : undefined,
    labelId: logQuery && logQuery.labelId ? logQuery.labelId : undefined,
    userEmail: logQuery && logQuery.userEmail ? logQuery.userEmail : undefined,
    start: logQuery && logQuery.start ? logQuery.start : 1,
    limit: logQuery && logQuery.limit ? logQuery.limit : 10,
    name: logQuery?.name,
  };

  const data = await client.request(query, variables);
  return data.transactionLogs as {
    data: ActivityLog[];
    page: number;
    size: number;
    total: number;
  };
};
